import _ from 'underscore';
import $ from 'jquery';
import Numeral from 'numeral';
import Cache from 'root/cache';
import View from 'view/base';
import View_Preview from 'view/session_replay/recent_session';
import Model_Session_Recording from 'model/session_recording';

export default View.extend({
    page: 1,
    total_loaded: 0,

    views: {
        session_recent: {}
    },

    events: {
        'click .load-more': 'onLoadmore'
    },

    dom_handlers: {
        onLoadmore: function(e) {
            this.page++;
            this.search();
        }
    },

    initialize: function(options) {
        this.user_identification = options.user_identification;
    },

    search: function() {
        this.$el.find('.load-more').hide();

        Cache.app.request({
            action: 'session_recording/search',
            data: {
                page                : this.page,
                limit               : 30,
                user_identification : this.user_identification,
                sort_order          : 'desc',
                sort_type           : 'timestamp'
            },
            success: (response) => {
                response.data.forEach((data) => {
                    var session_recording_model = new Model_Session_Recording(data);

                    this.views.session_recent['_' + data.id] = new View_Preview({
                        model: session_recording_model,
                        user_data: response.user_data
                    });
                    this.views.session_recent['_' + data.id].render().$el.insertBefore(this.$el.find('.load-more'));
                });

                if (response.total > _.size(this.views.session_recent)) {
                    this.$el.find('.load-more span').text('+ ' + Numeral(response.total - _.size(this.views.session_recent)).format('0,0') + ' more');
                    this.$el.find('.load-more').show();
                }

                this.$el.find('.list-count').text(Numeral(_.size(this.views.session_recent)).format('0,0') + ' of ' + Numeral(response.total).format('0,0') + ' Session' + (response.total === 1 ? '' : 's'));
                this.$el.find('.search-result-empty').toggleClass('active', response.data.length === 0);
            }
        });
    },

    render: function() {
        var content =
        '<div class="list-count"><div class="loader-placeholder-small" style="width:40px;"></div></div>' +
        '<div class="search-result-empty margin-top-12">No session replays found</div>' +
        '<div class="load-more"><span></span></div>';

        this.$el.html(content);

        this.search();

        return this;
    }
});